const scripts = require.context('.', true, /\.js$/)
const incrementer = require('./components/incrementer-component')
